<script lang="ts" setup>
import avatar from '@images/placeholder/avatar.png'
import { VTooltip } from 'vuetify/lib/components/index.mjs'

const { t } = useI18n()

const props = defineProps({
    job: {
        type: Object,
        default: () => ({})
    },
    border: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <VCard border class="h-100 position-relative" flat>
        <NuxtLink
            :to="`/job/${job.slug}`"
            class="h-100 d-block position-absolute h-100 w-100"
        />
        <VCardText class="d-flex pa-3 pa-md-4">
            <div class="d-flex flex-column gap-3">
                <div class="d-flex align-md-center gap-3">
                    <NuxtLink
                        :to="`/job/${job.slug}`"
                        class="position-relative"
                    >
                        <VAvatar
                            max-height="75"
                            max-width="75"
                            size="75"
                            :image="props.job.company?.logo_url || avatar"
                            rounded="0"
                        />
                    </NuxtLink>

                    <div class="d-flex w-100">
                        <div>
                            <NuxtLink
                                :to="`/company/${job.company?.slug}`"
                                class="position-relative text-body-2 text-primary mb-1 company-title text-truncate limit-title d-block"
                            >
                                {{ job.company?.name }}
                            </NuxtLink>
                            <h3 class="text-h6 mb-0 text-truncate limit-title">
                                {{ job.title }}
                            </h3>
                            <p
                                class="mb-1 text-body-2 text-truncate limit-title"
                            >
                                {{ job.category }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="d-flex gap-3 text-body-2 text-error limit-info">
                    <div
                        class="d-flex align-center gap-x-1 cursor-pointer"
                        style="min-width: 0"
                    >
                        <VIcon size="15" icon="ri-map-pin-line" />
                        <span class="d-inline-block text-truncate">
                            {{ job.location?.city }}
                        </span>
                    </div>

                    <div
                        class="d-flex align-center gap-x-1 cursor-pointer"
                        style="min-width: 0"
                    >
                        <VIcon size="15" icon="ri-briefcase-3-line" />
                        <span class="d-inline-block text-truncate">
                            {{ job.type }}
                        </span>
                    </div>
                </div>
            </div>
            <VSpacer />

            <div class="d-flex flex-column justify-space-between align-end">
                <ButtonSaved :job="job" />
                <div class="d-flex gap-3">
                    <VTooltip
                        :text="
                            (job.total_candidates ?? 0) +
                            ' ' +
                            t('candidates_applied')
                        "
                    >
                        <template v-slot:activator="{ props }">
                            <StatWithIcon
                                icon="ri-user-line"
                                :value="job.total_candidates ?? 0"
                                v-bind="props"
                            />
                        </template>
                    </VTooltip>
                    <VTooltip
                        :text="
                            (job.views_count ?? 0) +
                            ' ' +
                            t('views_on_this_job')
                        "
                    >
                        <template v-slot:activator="{ props }">
                            <StatWithIcon
                                icon="ri-eye-line"
                                :value="job.views_count ?? 0"
                                v-bind="props"
                            />
                        </template>
                    </VTooltip>
                </div>
            </div>
        </VCardText>
    </VCard>
</template>

<style lang="scss" scoped>
.v-card:hover {
    border-color: rgb(244 63 94);
    transition: border-color 0.5s ease;
    background-color: rgb(255, 249, 249);
}

.company-title:hover {
    text-decoration: underline;
}

.limit-title {
    max-width: 50vw;
}
.limit-info {
    max-width: 60vw;
}

@media (min-width: 960px) {
    .limit-title {
        max-width: 15vw;
    }
    .limit-info {
        max-width: 25vw;
    }
}

@media (min-width: 1280px) {
    .limit-title {
        max-width: 10vw;
    }
    .limit-info {
        max-width: 15vw;
    }
}
</style>
